export var addHexPrefix = function addHexPrefix(str) {
  return str.slice(0, 2) === '0x' ? str : "0x".concat(str);
};